


























































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ProjectUnitRow extends Vue {
    @Prop() unit!: Estate;

    get estateUrl() {
        // @ts-ignore
        let base = `${this.$root.possibleLangPrefix}/${this.unit.is_project ? "projecten" : "panden"}/${this.unit.slug}?`;

        if (this.unit.price.amount) {
            base += `&price=${this.unit.price.amount}`;
        }

        if (this.unit.type) {
            base += `&type=${this.unit.type}`;
        }

        if (this.unit.project_id) {
            base += `&nieuwbouw=true`;
        }

        return base;
    }
}
